export const Companies = {
  en: {
    'Create Company': 'Create Company',
    'Company details': 'Company details',
    'Required client signature photo': 'Required client signature photo',
    'Client insurance signature included':
      'Client insurance signature included',
    'Force location selection': 'Force location selection',
    'Maximum client debt, ₴': 'Maximum client debt, ₴',
    'Maximum client debt hint':
      'Selling on credit: how much a client may owe you when they pay by deposit and the balance is not enough. Enter the debt as a positive number — 300 means the balance may drop to −300 ₴. 0 turns credit off: paying by deposit then fails as soon as the balance runs out. Applies to every client of the company.',
    'Certificate validity, days': 'Certificate validity, days',
    'Certificate validity hint':
      'A certificate expires this many days after it is sold; its un-redeemed remainder then burns to revenue. Empty — no expiry. Applies to new certificates only.',
    'Lead climbing': 'Lead climbing',
  },
  uk: {
    'Create Company': 'Створити Компанію',
    'Company details': 'Деталі компанії',
    'Required client signature photo': "Обов'язкове фото підпису клієнта",
    'Client insurance signature included': 'Підпис страхування в клієнта',
    'Force location selection': 'Примусовий вибір локації',
    'Maximum client debt, ₴': 'Максимальний борг клієнта, ₴',
    'Maximum client debt hint':
      'Продаж у кредит: скільки клієнт може заборгувати, коли платить депозитом, а балансу не вистачає. Вводьте борг додатним числом — 300 означає, що баланс може опуститися до −300 ₴. 0 вимикає кредит: оплата депозитом не пройде, щойно баланс вичерпано. Діє для всіх клієнтів компанії.',
    'Certificate validity, days': 'Термін дії сертифіката, днів',
    'Certificate validity hint':
      'Сертифікат спливає через стільки днів після продажу, а його непогашений залишок згорає в дохід. Порожнє поле — без терміну дії. Діє лише на нові сертифікати.',
    'Lead climbing': 'Нижня Страховка',
  },
};

export const CompanyForm = {
  en: {
    ...Companies.en,
    Logo: 'Logo',
    'New Company': 'New Company',
    'Edit Company': 'Edit Company',
    'Update Company': 'Update Company',
    'Custom Fields': 'Custom Fields',
  },
  uk: {
    ...Companies.uk,
    Logo: 'Логотип',
    'New Company': 'Створення Компанії',
    'Edit Company': 'Редагування Компанії',
    'Update Company': 'Оновити Компанію',
    'Custom Fields': 'Додаткові поля',
  },
};
